module.exports = {
    topHead: {
        select_option_category: "类目",
        select_option_category_holder: "请选择类目",
        select_option_brand: "品牌",
        select_option_brand_holder: "请选择",
        select_option_postKeyWords: "帖子关键词",
        select_option_postKeyWords_holder: "请输入内容",
        rules_message_search: "品牌和帖子内容至少输入一个",
        my_attention: "我的关注",
        login_label: "登录",
        login_out: "退出",
        Chinese: "中文",
        English: "English",
        logo_title: "魔镜CMI",
        user_cases: "头部品牌都在看的场景大全",
    },
    inspiration: {
        // TODO: 标题候选 - 1.魔镜洞察平台 2.魔镜市场智能平台 3.魔镜·消费品商业智能 — 用户确认后替换
        title: "魔镜CMI平台",
        // TODO: 统领文案候选（用户挑选后替换）:
        // 1. AI驱动 + 全量数据，一站式支撑市场研究与消费者洞察
        // 2. 融合AI智能分析与电商社媒数据，赋能消费品市场研究和消费者洞察
        // 3. 从数据到洞察，AI让消费品市场研究更快更准
        // 4. 整合销售·评论·社媒三大数据源，以AI驱动市场研究与消费者洞察
        // 5. 全量消费品数据 × AI深度分析 = 极速市场洞察
        subtitle_unified: "整合销售·评论·社媒三大数据源，以AI驱动市场研究与消费者洞察",
        data_products_label: "数据产品",
        // 方案D: 数据类型标签
        data_type_ecommerce: "电商数据",
        data_type_review: "评论数据",
        data_type_social: "社媒数据",
        data_type_overseas: "海外数据",
        data_type_trend: "趋势发现",
        // 方案D: AI 块
        ai_engine_desc: "你的AI分析助理",
        // 方案D: 对比表
        compare_traditional: "传统数据分析",
        compare_ai: "镜界AI分析",
        compare_t1: "手动切换多个平台",
        compare_t2: "数据导出 + Excel 分析",
        compare_t3: "数小时到数天",
        compare_t4: "需要专业分析师",
        compare_a1: "一站式自然语言提问",
        compare_a2: "AI 自动整合分析输出",
        compare_a3: "分钟级数据分析",
        compare_a4: "业务人员直接使用",
        ai_value1: "会深度思考的消费品商业分析Agent",
        ai_value2: "自然语言交互，零门槛上手",
        ai_value3: "多源数据智能融合分析，可溯源",
        comma: "、",
        unify_sales: "整合销售",
        review: "评论",
        social: "社媒",
        data_total: "三大数据源，助力",
        consumer: "市场研究",
        and: "和",
        market_insight: "消费者洞察",
        subtext: "（Consumer & Market Insight， 简称CMI）",
        analysis: "魔镜分析+",
        comment: "电商聆听",
        brand_listen: "社交聆听",
        deepseek_AI: "接入DeepSeek",
        oversea: "海外电商Oversea",
        chance: "增长雷达",
        insight_AI: "镜界AI",
        taobao: "淘宝",
        tmall: "天猫",
        jd: "京东",
        douyin: "抖音",
        // label_amazon: "Amazon",
        bilibili: "B站",
        social_platforms: "10家主流社媒平台",
        global_E_commerce: "海外电商",
        market_research: "极速市场调研",
        performance_platforms: "平台打通，一键查看主流电商销售表现",
        identify_emerging: "全量商品数据，把握潜力市场与新兴趋势",
        define_custom: "灵活定义细分市场，研判市场进入可行性",
        analyze_brand: "AI驱动，高效精准的消费者评论分析",
        benchmark_product: "品类/品牌/产品口碑分析，捕捉消费者痛点",
        discover_innovation: "从消费者场景/需求出发挖掘产品创新机会",
        analyze_product: "AI提取人货场标签，从社媒数据分析产品趋势",
        understand_consumer: "品类/场景/人群分析，发现消费者生活方式",
        optimize_marketing: "话题/代言人/IP分析，优化品牌营销决策",
        access_comprehensive: "欧美/日本/中东/东南亚全品类电商数据",
        validate_international: "灵活筛选，验证海外细分市场潜力",
        leverage_analytics: "立足魔镜品牌服务经验，助力出海决策",
        discover_high_growth: "海内外高增长概念/品类/品牌一站式查看",
        find_blue_ocean: '海量蓝海概念，无穷产品创新灵感',
        instantly_spot: "社媒高增概念，热点话题一网打尽",
        instant_market: "会深度思考的消费品商业分析Agent",
        complex_business: "集成CMI产品数据，一键分析市场",
        generate_comprehensive: "桌面调研+市场数据，全面支撑结论",
        // TODO: 以下两条旧文案已弃用（保留防止其他引用报错）
        ai_layer_headline: "AI能力层 — 基于CMI全量数据的智能分析引擎",
        data_layer_desc: "数据产品 · 为镜界AI提供全量电商与社媒数据基础",
        get_started: "开始使用",
        ai_get_started: "立即体验",
        try_free: "该产品未合作，您可以免费试用",
        start_now: "天，请问您是否要现在开始试用",
        yes: "是",
        no: "否",
        trial_expire: "试用时间到期，如需再开通，请联系对应销售申请",
        amazon: "亚马逊",
        amazon_us: "亚马逊美国站",
        amazon_de: "亚马逊德国站",
        amazon_es: "亚马逊西班牙",
        amazon_fr: "亚马逊法国站",
        amazon_it: "亚马逊意大利站",
        amazon_uk: "亚马逊英国站",
        amazon_jp: "亚马逊日本站",
        shopee: "虾皮",
        shopee_vn: "虾皮越南站",
        shopee_th: "虾皮泰国站",
        shopee_sg: "虾皮新加坡站",
        shopee_my: "虾皮马来西亚站",
        shopee_ph: "虾皮菲律宾站",
        shopee_id: "虾皮印尼站",
        shopee_tw: "虾皮中国台湾站",
        lazada: "来赞达",
        lazada_vn: "来赞达越南站",
        lazada_th: "来赞达泰国站",
        lazada_sg: "来赞达新加坡站",
        lazada_my: "来赞达马来西亚站",
        lazada_ph: "来赞达菲律宾站",
        lazada_id: "来赞达印尼站",
    },
    inspTh: {
        analyze_name: "名称",
        product_name: "产品",
        plat: "平台/类目",
        publish_user: "作者",
        publish_time: "发布时间",
        share_count: "添加次数",
        operation: "操作",
    },
    footer: {
      data_E_commerce: "数据由公开页面采集并汇总处理，数据口径和平台及其他机构有所不同，仅供参考，如有差异请以平台官方发布数据为准",
      company: " ©2025 北京淘幂科技有限公司 ",
      ICP_number: "京ICP备15061734号-4",
      network_security: "京公网安备 11010502037832号",
    },
};